<template>
  <div class="packages-module">

    <div class="info-box d-flex flex-column mx-auto mt-3 align-items-center">
        <h3>{{name}}</h3>
        <img :src="image">
    </div>


    <div class="main-box">
        <h4 class="text-center">آژانس {{agname}}</h4>
        <div class="main-des-box text-end">
            <p>توضیحات:</p>
            <p>{{des}}</p>
        </div>
    </div>
    <div class="price-box mt-3 text-center text-white"> قیمت:  {{price | toPersianCurrency("تومان",0)}}</div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      id: null,
      name: null,
      des: null,
      agname: null,
      imahe: null,
    };
  },
  created() {
    this.getPackage();
  },
  methods: {
    async getPackage() {
        if(this.$route.params.price){
          this.id = this.$route.params.id;
          this.name = this.$route.params.name;
          this.des = this.$route.params.des;
          this.image = this.$route.params.image;
          this.price = this.$route.params.price;
          this.agname = this.$route.params.agname;
        }else{
          this.$toast.open({
            message: 'اطلاعات به درستی دریافت نشد،به صفحه اصلی باز میگردید.',
            type: 'error',
          });

          setTimeout(()=>{
            this.$router.push("/packages");
          },2000);
        }
    },
  },
};
</script>

<style lang="scss" scoped>
.packages-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/onepack_back.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 10px;
  .info-box{
    //width: 105px;
    width: 100%;
    height: auto;
    border-radius: 50%;
    margin: 13px;
    img{
      width: 117px;
      height: 117px;
      border-radius: 50%;
    }
    h3{
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
  .main-box{
    height: 383px;
    padding: 10px;
    border-radius: 18px;
    background-color: rgb(0 0 0 / 43%);
    margin-top: 20px;
    width: 100%;
    h4{
      color: #ffffff;
    }
    .main-des-box{
      p{
        color: #ffffff;
        direction: rtl;
      }
    }
  }
  .price-box{
    background-color: rgb(0 0 0 / 43%);
    padding: 16px;
    border-radius: 25px;
    font-weight: bold;
    font-size: 17px;
  }
}
</style>
